<template>
  <div class="tw-relative">
    <Loader v-show="loading || calculating" position="fixed" class="mv-4" />
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Total $</th>
            <th scope="col">/ CWT</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Revenue Guarantee</td>
            <td><Currency :value="quote.revGuarantee" /></td>
            <td><Cwt :value="quote.revGuarantee" :milkProduction="milkProduction" /></td>
          </tr>
          <tr>
            <td>Premium Before Subsidy</td>
            <td><Currency :value="quote.totalPremiumAmount" /></td>
            <td><Cwt :value="quote.totalPremiumAmount" :milkProduction="milkProduction" /></td>
          </tr>
          <tr>
            <td>Subsidy</td>
            <td><Currency :value="quote.subsidyAmount" /></td>
            <td><Cwt :value="quote.subsidyAmount" :milkProduction="milkProduction" /></td>
          </tr>
          <tr class="table-warning">
            <td>Premium After Subsidy</td>
            <td><Currency :value="quote.producerPremiumAmount" /></td>
            <td><Cwt :value="quote.producerPremiumAmount" :milkProduction="milkProduction" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapState, mapMutations } from 'vuex';
import { perCWT } from '../scripts/utils';
import Currency from './Currency.vue';
import Cwt from './Cwt.vue';
import Loader from './Loader.vue';

export default {
  components: { Currency, Cwt, Loader },
  data() {
    return {};
  },
  computed: {
    ...mapState([
      'calculating',
      'milkProduction',
      'loading',
      'queryLoaded',
      'quarter',
    ]),
    ...mapGetters([
      'subsidyAmount',
      'quote',
    ]),
  },
  methods: {
    ...mapMutations(['updateLoading']),
    perCWT,
  },
};
</script>
